export const DEFAULT_TIMEZONE = "America/Los_Angeles";

export const DEFAULT_VISIBILITY = "public" as const;
